import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class BrixContactList {
  static init(...parameters) {
    return new BrixContactList(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    const IE = isIEbrowser();
    this.poster = selector.querySelector('.image');

    if (this.poster && IE) {
      window.objectFitPolyfill();
    }
  }
}

//  Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-contact-list', BrixContactList.init);
}
